import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import tw from 'twin.macro';

const Container = styled.div`
  ${tw`flex flex-col items-center justify-center relative`}
  ${({ overlapTop }) =>
    overlapTop &&
    `
    margin-top: -.35rem !important;
  `}
`;

const Text = styled.h2.attrs(({ className }) => ({
  className: `font-trade-gothic-20 text-mattamy-blue text-2xl lg:text-4xl uppercase mt-4 text-center ${className}`,
}))`
  ${({ small }) =>
    small &&
    `
    font-size: 1.75rem !important;
  `}
`;

const SectionTitle = ({ title, noAquaBar, small, overlapTop }) => {
  const value = typeof title === 'object' ? title : { value: title };

  return (
    <Container overlapTop={overlapTop}>
      {!noAquaBar && <span className='bg-aqua w-full h-3 mx-1' />}
      <Text small={small}>
        <RichText tag='span' className='richtext' field={value} />
      </Text>
    </Container>
  );
};

export default SectionTitle;
